import type { ReactNode } from 'react';
import { useAvatarImageUrl } from '@/hooks';

export interface ProfileBadgeProps {
  name: string;
  emoji?: string;
  avatar?: ReactNode;
  color?: string;
  /** Storage path that resolves to a signed URL via useAvatarImageUrl. */
  imagePath?: string | null;
  className?: string;
}

export function ProfileBadge({
  name,
  emoji,
  avatar,
  color,
  imagePath,
  className = '',
}: ProfileBadgeProps) {
  const { url } = useAvatarImageUrl(imagePath ?? null);

  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-2.5 py-0.5 text-xs font-medium text-foreground',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {url ? (
        <img
          src={url}
          alt={name}
          className="inline-block w-5 h-5 rounded-full object-cover shrink-0"
        />
      ) : (
        (emoji || avatar) && (
          <span
            className="inline-flex items-center justify-center w-5 h-5 rounded-full text-xs shrink-0"
            style={color ? { backgroundColor: color } : undefined}
          >
            {emoji || avatar}
          </span>
        )
      )}
      {name}
    </span>
  );
}
